/**
 * The sections of the settings hub. The URL names one of them, so this list is also what decides
 * whether an address like `/main/user-settings/<x>` is a real page — see the `canMatch` in the
 * route table.
 */
export const PROFILE_SECTIONS = ['profile', 'security', 'appearance', 'privacy', 'knowledge-base', 'lizzie-mcp', 'system', 'live-assistant'] as const;

export type ProfileSection = (typeof PROFILE_SECTIONS)[number];

export const isProfileSection = (segment: string | undefined): segment is ProfileSection => PROFILE_SECTIONS.some(section => section === segment);
